// ! derived

import { getDataAt } from "../utils";

export const D = Object.freeze({
  SUM: "SUM",
  AVG: "AVG",
  MIN: "MIN",
  MAX: "MAX",
  COUNT: "COUNT",
});

export const handleDerived = (
  allData,
  allSchema,
  selfInfoObject,
  selfPath,
  selfSchema
) => {
  if (!selfSchema.summary) return undefined;

  const itemType = selfSchema.item.type;

  if (!itemType.startsWith("__"))
    throw new Error("Cannot derive from non-entity", selfSchema);

  const field = selfSchema.summary.derived.field;
  const derivedQueryPath = `${selfPath}.[*]` + (field ? `.${field}` : "");
  const derivedOperation = selfSchema.summary.derived.operation;

  const derivedData = getDataAt(
    allData,
    allSchema,
    selfInfoObject,
    derivedQueryPath
  );

  switch (derivedOperation) {
    case D.SUM:
      if (!numDataValidator(derivedData))
        throw new Error("SUM operation requires numeric data", derivedData);
      return derivedData.reduce((acc, item) => acc + item.__data, 0);

    case D.AVG:
      if (!numDataValidator(derivedData))
        throw new Error("AVG operation requires numeric data", derivedData);
      return Number(
        (
          derivedData.reduce((acc, item) => acc + item.__data, 0) /
          derivedData.length
        ).toFixed(2)
      );

    case D.MIN:
      if (!numDataValidator(derivedData))
        throw new Error("MIN operation requires numeric data", derivedData);
      return Math.min(...derivedData.map((item) => item.__data));

    case D.MAX:
      if (!numDataValidator(derivedData))
        throw new Error("MAX operation requires numeric data", derivedData);
      return Math.max(...derivedData.map((item) => item.__data));

    case D.COUNT:
      return derivedData.length;

    default:
      break;
  }

  return undefined;
};

export const numDataValidator = (data) => {
  // ensure all __data values are numbers
  return data.every((item) => {
    const value = item.__data;
    return typeof value === "number" && !isNaN(value);
  });
};
